import React from 'react';
import { Button, Dropdown } from 'antd';
import { CloseCircleOutlined, DownCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';

class Action extends React.Component {
    render() {
        const { row, action, modalDelete } = this.props;
        const items = [];

        if (!action.detail && !action.update && !action.delete) {
            return "-"
        }

        if (action.detail) {
            items.push({
                key: '1',
                label: "Detail",
                icon: <InfoCircleOutlined />,
                onClick: () => {
                    this.props.history.push("/kurikulum/rombel/detail/" + row.id)
                },
            })
        }

        if (action.delete) {
            items.push({
                key: '2',
                label: "Delete",
                icon: <CloseCircleOutlined />,
                onClick: () => {
                    modalDelete(true, row)
                },
            })
        }

        return (
            <Dropdown
                trigger={['click']}
                menu={{ items }}
            >
                <Button type="primary">
                    Opsi <DownCircleOutlined style={{ fontSize: 11 }} />
                </Button>
            </Dropdown>
        );
    }
}


export default React.memo(withRouter(Action));
